// Source/Sales-Page/Component.ts
var parser = new DOMParser;
var parseHTML = (html) => parser.parseFromString(html, "text/html");
var querySections = (document) => document.querySelectorAll(`main > *`);

class SalesPageSection extends HTMLElement {
  connectedCallback() {
    this.render();
  }
  async render() {
    const path = `/pages/${this.handle}`;
    const url = new URL(path, location.href);
    const sections = await fetch(url).then((response) => response.text()).then(parseHTML).then(querySections);
    const nodes = Array.from(sections);
    this.replaceChildren(...nodes);
  }
  get handle() {
    return this.dataset.handle;
  }
}

// Source/Sales-Page/mod.ts
customElements.define("sales-page-section", SalesPageSection);
